<div class="content">

    <div class="header">{{ 'bikeshop.shop_profile.collections.unavailable_dates' | translate }}</div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !data.date}">{{
            'bikeshop.shop_profile.collections.unavailable_date' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.date" [selectOtherMonths]="true" [disabledDays]="disabledDays"
                            [minDate]="minDate" [dateFormat]="countryData.DatePickerFormat">
                </p-calendar>
            </div>
        </div>
        <div class="col-md-5 flex">
            <small class="red">{{ 'bikeshop.shop_profile.collections.only_see_configured_slots' | translate }}</small>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !data.startTime}">{{
            'bikeshop.shop_profile.collections.slot_start_time' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.startTime" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly">
                </p-calendar>
            </div>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !data.endTime || data.endTime <= data.startTime}">{{
            'bikeshop.shop_profile.collections.slot_end_time' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.endTime" [timeOnly]="true" [hourFormat]="'12'"
                            inputId="timeonly"></p-calendar>
            </div>
        </div>
    </div>

</div>

<div class="content">
    <div class="row">
        <div class="col-md-4 label" style="margin-top: 0px;"
             [ngClass]="{invalid: !selectedVehicles || selectedVehicles.length === 0}">{{
            'bikeshop.shop_profile.collections.linked_vehicles' | translate }}</div>
        <div class="col-md-8 vehicles">
            <div *ngFor="let vehicle of vehicles">
                <div>
                    <p-checkbox name="linkedVehicles" value="{{vehicle.id}}"
                                [(ngModel)]="selectedVehicles"></p-checkbox>
                </div>
                <div class="label">{{vehicle.name}}</div>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="row margin-bottom-16" *ngIf="!valid()">
        <div class="col-md-12 invalid">{{ 'bikeshop.shop_profile.collections.validation_message' | translate }}</div>
    </div>

    <div class="row">
        <div class="col-md-8 label"></div>
        <div class="col-md-4">
            <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
                    label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
                    [disabled]="saving || !valid()"></button>
        </div>
    </div>
</div>
